import {React, lazy, Suspense, useEffect, useState, useRef, useLayoutEffect} from 'react';
import { Helmet } from "react-helmet";
import '../App.css';
import './index2.css';
//import BGwordanimation from './BGwordanimation.js'
import PosterImage from '../images/Sams_first_pic2.webp';
import SlideInDiv from './slider.js'
import SlideInDivLeft from './slider2.js'
import useHorizontalScroll from './useHorizontalScroll';
import Testimonials from './testimonials.js'
import Image1 from '../images/image1.webp';
//import Image3 from '../images/image3.jpg';
import Image4 from '../images/image4.webp';
import Image5 from '../images/image5.webp';
import Image6 from '../images/image6.webp';
import Image7 from '../images/image7.webp';
//import Image8 from '../images/image8.jpg'; 
import Image9 from '../images/image9.webp';
import Image10 from '../images/image10.webp';
import Image12 from '../images/image12.webp';
//import Image14 from '../images/image14.jpeg';
//import Image15 from '../images/image15.jpg';
import Image113 from '../images/image113.webp';
import Image45 from '../images/image45.webp';
import Image48 from '../images/image48.webp';
import Image52 from '../images/image52.webp';
import Image89 from '../images/image89.webp';
import Image91 from '../images/image91.webp';
//import Title_video from '../images/SamsCut4_5.mp4';
import Quest_video from '../images/SamsShort2.mp4';
import UserModal from '../pages/UserModal';
import 'bootstrap-icons/font/bootstrap-icons.css';
import { useNavigate } from "react-router-dom";
import { useScrollBehavior } from './useScrollBehavior.js';
import ReactCurvedText from "react-curved-text";
import { IoSchoolOutline } from "react-icons/io5";
import { LuShieldAlert } from "react-icons/lu";
import { GiTreeBranch } from "react-icons/gi";
import { TbTrees } from "react-icons/tb";
//import { GiPineTree } from "react-icons/gi";
import { GiPalmTree } from "react-icons/gi";
import { GiBirchTrees } from "react-icons/gi";
import { GiFruitTree } from "react-icons/gi";
import { GiWillowTree } from "react-icons/gi";
import { TbShieldCheckFilled } from "react-icons/tb";
//import { IoArrowRedoCircle } from "react-icons/io5";
import { FaArrowAltCircleRight } from "react-icons/fa";
import { GiAxeInStump } from "react-icons/gi";
import { GiStumpRegrowth } from "react-icons/gi";
import { GiTruck } from "react-icons/gi";
import { LuTrees } from "react-icons/lu";
import Collapsible from "./Collapsible";
import { Link } from 'react-router-dom';
import ExpandedImage from './ExpandedImage.js';
//import Gallery from './gallery.js'
import { createPortal } from 'react-dom';
import Arborist from './arborist.js'
import Footer from './footer4.js'

const testimonialsData = [
	{
	  name: 'Michael B',
	  review: 'Sam’s Tree Service did an amazing job! Highly recommend.',
	  image: Image4, 
	},
	{
	  name: 'Mrs Tran',
	  review: 'Affordable and professional service. My yard looks great!',
	  image: Image5,
	},
	{
	  name: 'Denies H',
	  review: 'Quick and efficient! The team was courteous and clean.',
	  image: Image6,
	},
	{
	  name: 'Marilyn Neil',
	  review: 'They removed a dangerous tree with precision and care.',
	  image: Image7,
	},

	{
		name: 'Wendy Sestito',
		review: 'When I got home from work the trees were done and you would have never know they were here.',
		image: Image91,
	  },

	  {
		name: 'Rick Butera',
		review: 'I was truly impressed by their work ethics.',
		image: Image89,
	  },  

	
  ];
  

const Home = () => {

	useScrollBehavior();
	
	const { scrollRef, scrollLeft, scrollRight } = useHorizontalScroll();
	const stickyRef = useRef(null);
  	const overlayRef = useRef(null);
	//const [windowWidth, setWindowWidth] = useState(window.innerWidth);
	//const [viewportWidth, setViewportWidth] = useState(window.innerWidth);
	const [viewportWidth, setViewportWidth] = useState(0);
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [isVisibleLinks, setIsVisibleLinks] = useState(false);
	const [isVisibleCenter, setIsVisibleCenter] = useState(false);
	const [isVisibleText, setIsVisibleText] = useState(false);
	const [isVisibleImage, setIsVisibleImage] = useState(false);
	const linksRef = useRef(null);
	const centerRef = useRef(null);
	const textRef = useRef(null);
	const imageRef = useRef(null);
	const openModal = () => setIsModalOpen(true);
	const closeModal = () => setIsModalOpen(false);
	const [expandedImage, setExpandedImage] = useState(null);
	const [count, setCount] = useState(0);
	const [percentage, setPercentage] = useState(0);
	const [experience, setExperience] = useState(0); 
	const ref = useRef(null);
	const ref2 = useRef(null);
	const ref3 = useRef(null);
	const navigate = useNavigate(); 
	const videoRef = useRef(null);
	const videoSrc = "https://d3q39nywk1l3el.cloudfront.net/static/media/SamsCut4_5.634078552d9891500f64.mp4";
	const Gallery = lazy(() => import('./gallery.js'));
	const [openCounty, setOpenCounty] = useState(null);
	const [menuPosition, setMenuPosition] = useState({ top: 0, left: 0, width: 220 });
	const countyButtonRefs = useRef({});
	const moduleThreeRef = useRef(null);
	const [moduleThreeBgLoaded, setModuleThreeBgLoaded] = useState(false);

	const handleNavigation = () => {
		navigate("/about"); // Replace with your target page route
	  };

	  const handleNavigation2 = () => {
		navigate("/reviews"); // Replace with your target page route
	  };  

	  const handleNavigation3 = () => {
		navigate("/blog"); // Replace with your target page route
	  };  

	
const openCountyMenu = (county, event) => {
  const rect = event.currentTarget.getBoundingClientRect();

  setMenuPosition({
    top: rect.bottom + window.scrollY + 6,
    left: rect.left + window.scrollX,
    //width: Math.max(rect.width, 220),
	width: window.innerWidth <= 600 ? window.innerWidth - 80 : Math.max(rect.width, 220),
  });

  setOpenCounty(county);
};

const closeCountyMenu = () => {
  setOpenCounty(null);
};
  
	// Update windowWidth when the window is resized
  useEffect(() => {
    const handleResize = () => {
		setViewportWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    
    // Cleanup listener when component unmounts
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);


  useEffect(() => {
  const observer = new IntersectionObserver(
    (entries) => {
      if (entries[0].isIntersecting) {
        setModuleThreeBgLoaded(true);
        observer.disconnect(); // Only need to load once
      }
    },
    { rootMargin: '500px' } // Start loading 500px BEFORE it enters the viewport
  );

  if (moduleThreeRef.current) observer.observe(moduleThreeRef.current);

  return () => observer.disconnect();
}, []);

  /*useLayoutEffect(() => {
    if (videoRef.current) {
      const sourceElement = videoRef.current.querySelector('source');
      if (sourceElement && sourceElement.src !== videoSrc) {
        sourceElement.src = videoSrc;
       
		videoRef.current.play().catch((e) => {
     
    });
      }
    }
  }, [videoSrc]);*/


	const slideUpAnimation = {
		hidden: { opacity: 0, y: 100 },
		visible: {
			opacity: 1,
			y: 0,
			transition: {
				duration: 1,
				delay: .8,
				ease: "easeInOut"
			}
		}
	};


  useEffect(() => {
    const handleScroll = () => {
		if (window.innerWidth <= 440) {
            // If the viewport is 440px or less, explicitly set to absolute and return.
            overlayRef.current.style.position = 'relative';
            overlayRef.current.style.top = '0';
            return;
		  }
      const stickyRect = stickyRef.current.getBoundingClientRect();
      const overlayRect = overlayRef.current.getBoundingClientRect();

      if (stickyRect.top <= 0 && stickyRect.bottom > overlayRect.height) {
        overlayRef.current.style.position = 'fixed';
        overlayRef.current.style.top = '0';
        /*overlayRef.current.style.width = `${stickyRef.current.offsetWidth}px`;*/
      } else if (stickyRect.bottom <= overlayRect.height) {
        overlayRef.current.style.position = 'absolute';
        overlayRef.current.style.top = `${stickyRect.height - overlayRect.height}px`;
      } else {
        overlayRef.current.style.position = 'absolute';
        overlayRef.current.style.top = '0';
      }
    };
	
	

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);


  /*const handleScroll2 = () => {
	if (linksRef.current) {
	  const linksRect = linksRef.current.getBoundingClientRect();
	  const triggerOffsetLinks = 100;
	  const triggerPointLinks = window.innerHeight - triggerOffsetLinks;
	  const isAboveTriggerPointLinks = linksRect.top < triggerPointLinks;
	  setIsVisibleLinks(isAboveTriggerPointLinks);
	}

	if (centerRef.current) {
	  const centerRect = centerRef.current.getBoundingClientRect();
	  const triggerOffsetCenter = 200; // Adjust this value for different trigger points
	  const triggerPointCenter = window.innerHeight - triggerOffsetCenter;
	  const isAboveTriggerPointCenter = centerRect.top < triggerPointCenter;
	  setIsVisibleCenter(isAboveTriggerPointCenter);
	}

	if (textRef.current) {
		const textRect = textRef.current.getBoundingClientRect();
		const triggerOffsetText = 300; // Adjust this value for different trigger points
		const triggerPointText = window.innerHeight - triggerOffsetText;
		const isAboveTriggerPointText = textRect.top < triggerPointText;
		setIsVisibleText(isAboveTriggerPointText);
	  }

	  if (imageRef.current) {
		const imageRect = imageRef.current.getBoundingClientRect();
		const triggerOffsetImage = 130; // Adjust this value for different trigger points
		const triggerPointImage = window.innerHeight - triggerOffsetImage;
		const isAboveTriggerPointImage = imageRect.top < triggerPointImage;
		setIsVisibleImage(isAboveTriggerPointImage);
	  }
  };

  useEffect(() => {
	window.addEventListener('scroll', handleScroll2);
	handleScroll2(); // Check visibility on initial render
	return () => {
	  window.removeEventListener('scroll', handleScroll2);
	};
  }, []);*/

  useEffect(() => {
  const observer = new IntersectionObserver(
    (entries) => { if (entries[0].isIntersecting) setIsVisibleLinks(true); },
    { rootMargin: '0px 0px -100px 0px' }
  );
  if (linksRef.current) observer.observe(linksRef.current);
  return () => observer.disconnect();
}, []);

useEffect(() => {
  const observer = new IntersectionObserver(
    (entries) => { if (entries[0].isIntersecting) setIsVisibleCenter(true); },
    { rootMargin: '0px 0px 200px 0px' }
  );
  if (centerRef.current) observer.observe(centerRef.current);
  return () => observer.disconnect();
}, []);

useEffect(() => {
  const observer = new IntersectionObserver(
    (entries) => { if (entries[0].isIntersecting) setIsVisibleText(true); },
    { rootMargin: '0px 0px 300px 0px' }
  );
  if (textRef.current) observer.observe(textRef.current);
  return () => observer.disconnect();
}, []);

useEffect(() => {
  const observer = new IntersectionObserver(
    (entries) => { if (entries[0].isIntersecting) setIsVisibleImage(true); },
    { rootMargin: '0px 0px 130px 0px' }
  );
  if (imageRef.current) observer.observe(imageRef.current);
  return () => observer.disconnect();
}, []);

	//useEffect(() => {
		// Scroll to the top when the component mounts
		//window.scrollTo(0, 0);
	  //}, []); // Empty dependency array ensures this effect runs only once
	
	
	useEffect(() => {
		const hash = window.location.hash.substring(1);
		if (hash) {
		  const targetElement = document.getElementById(hash);
		  if (targetElement) {
			targetElement.scrollIntoView({ behavior: 'smooth' });
		  }
		}
	  }, []);

	  /*const collapsibleData = [
		{ title: "Can I Remove a Tree That's Too Close to My House?", content: "Yes, while a tree near your home can offer shade and beauty, it can also become a hazard over time. Falling leaves and debris may cause moisture damage, and overgrown branches can damage your siding or roof. Worse, an extensive root system could jeopardize your foundation. If the tree is becoming a problem, Sam's is a tree cutting service that can safely handle removal. Tree removal cost will vary depending on the size and location, and sometimes tree felling is needed. After removal, tree root removal can ensure that no regrowth threatens your home's foundation. Book an appointment today to get a free Tree removal estimate!" },
		{ title: "Do I Need a Permit to Remove a Tree?", content: "It depends. Many areas require a permit for tree removal, especially if the tree is large, located in a specific area, or considered a hazard. Factors like whether the tree is on public property, an invasive species, or near a street can also influence the need for a permit. An Arborist tree service like Sam's Tree Service, a licensed tree removal service in Sarasota and surrounding areas, can help assess whether you need a permit. As a certified arborist tree service and trusted tree specialist in the area, we'll guide you through the process and assist with any necessary applications." },
		{ title: "Do I need to be present while the tree work is being done?", content: "No, it's not necessary for you to be home as long as we have access to the property. Our team is fully equipped to handle the work independently, ensuring everything is done efficiently and safely." },
		{ title: "How much does tree trimming cost, and do you offer palm tree trimming services?", content: "The tree trimming cost depends on the size and type of the tree, as well as the complexity of the job. We offer specialized palm tree trimming services, ensuring your palms stay healthy and well-maintained. At Sam's Tree Service, we provide an affordable tree cutting service while delivering high-quality results. If you're looking for reliable tree trimmers in the Sarasota and Southwest Florida area , our experienced team is here to assist." },
	  ];*/

	  const collapsibleData = [
  {
    title: "Can I Remove a Tree That's Too Close to My House?",
    content: "Yes. Trees too close to your home can damage siding, roof, and even foundations over time. At Sam's Tree Service in Sarasota, our licensed arborists safely remove hazard trees of all sizes. Tree removal cost varies based on tree size and location. We also provide professional stump grinding and root removal to prevent regrowth. Contact us for a free tree removal estimate."
  },
  {
    title: "Do I Need a Permit to Remove a Tree?",
    content: "In many areas, you may need a permit for tree removal especially for large trees, heritage species, or public right-of-way removals. Sam's Tree Service can assess your situation, determine if a permit is required in Sarasota and surrounding areas, and assist with applications when needed."
  },
  {
    title: "Do I Need to Be Present While the Tree Work Is Being Done?",
    content: "No. You don't need to be onsite during tree removal or trimming as long as we have safe access to your property. Our team completes jobs efficiently using proper safety protocols."
  },
  {
    title: "How Much Does Tree Trimming Cost and Do You Offer Palm Tree Services?",
    content: "Tree trimming costs depend on tree size, species, and complexity of the job. We offer specialized palm tree trimming to keep palms healthy and properly shaped. Sam's Tree Service provides dependable, affordable tree trimming throughout Sarasota and Southwest Florida. Request a quote today."
  }
];


	  

	 
		
	 	


		useEffect(() => {
			// Set up the intersection observer for the first element (reviews)
			const observer = new IntersectionObserver(
			  (entries) => {
				entries.forEach(({ isIntersecting, target }) => {
				  if (isIntersecting) {
					if (target === ref.current) {
					  let start = 0;
					  const end = 100;
					  const duration = 2000;
					  const stepTime = 10;
					  const increment = (end - start) / (duration / stepTime);
		
					  const timer = setInterval(() => {
						start += increment;
						if (start >= end) {
						  start = end;
						  clearInterval(timer);
						}
						setCount(Math.floor(start));
					  }, stepTime);
					}
				  }
				});
			  },
			  { threshold: 0.5 }
			);
		
			if (ref.current) observer.observe(ref.current);
		
			return () => {
			  if (ref.current) observer.unobserve(ref.current);
			};
		  }, []);
		
		  useEffect(() => {
			// Set up the intersection observer for the second element (satisfaction percentage)
			const observer2 = new IntersectionObserver(
			  (entries) => {
				entries.forEach(({ isIntersecting, target }) => {
				  if (isIntersecting) {
					if (target === ref2.current) {
					  let start = 0;
					  const end = 100;
					  const duration = 2000;
					  const stepTime = 10;
					  const increment = (end - start) / (duration / stepTime);
		
					  const timer = setInterval(() => {
						start += increment;
						if (start >= end) {
						  start = end;
						  clearInterval(timer);
						}
						setPercentage(Math.floor(start));
					  }, stepTime);
					}
				  }
				});
			  },
			  { threshold: 0.5 }
			);
		
			if (ref2.current) observer2.observe(ref2.current);
		
			return () => {
			  if (ref2.current) observer2.unobserve(ref2.current);
			};
		  }, []);
		
		  useEffect(() => {
			// Set up the intersection observer for the third element (years of experience)
			const observer3 = new IntersectionObserver(
			  (entries) => {
				entries.forEach(({ isIntersecting, target }) => {
				  if (isIntersecting) {
					if (target === ref3.current) {
					  let start = 0;
					  const end = 10;
					  const duration = 2000;
					  const stepTime = 10;
					  const increment = (end - start) / (duration / stepTime);
		
					  const timer = setInterval(() => {
						start += increment;
						if (start >= end) {
						  start = end;
						  clearInterval(timer);
						}
						setExperience(Math.floor(start));
					  }, stepTime);
					}
				  }
				});
			  },
			  { threshold: 0.5 }
			);
		
			if (ref3.current) observer3.observe(ref3.current);
		
			return () => {
			  if (ref3.current) observer3.unobserve(ref3.current);
			};
		  }, []);
		  

		  /*useEffect(() => {
			if (videoRef.current) {
			  videoRef.current.src = Title_video;
			}
		  }, []);*/

		  useEffect(() => {
			const handleFocus = () => {
				if (videoRef.current && videoRef.current.paused) {
					videoRef.current.play().catch(error => {
						// Handle potential autoplay errors (browsers might block if no user interaction)
						console.error("Autoplay prevented on focus:", error);
						// Optionally, you could try to play with a slight delay or after a user interaction
					});
				}
			};
	
			window.addEventListener('focus', handleFocus);
	
			return () => {
				window.removeEventListener('focus', handleFocus);
			};
		}, []);

		
		/*useEffect(() => {

			const videoUrl = "https://d3q39nywk1l3el.cloudfront.net/static/media/SamsCut4_5.634078552d9891500f64.mp4";
		
			const preloadVideo = document.createElement('link');
		
			preloadVideo.rel = 'preload';
		
			preloadVideo.href = videoUrl;
		
			preloadVideo.as = 'video';
		
			preloadVideo.type = 'video/mp4';
		
			document.head.appendChild(preloadVideo);
		
		  }, []); */

const countyData = [
  {
    county: 'Sarasota County',
    cities: [
      { name: 'Sarasota', path: '/tree_service_sarasota' },
	  { name: 'Bee Ridge', path: '/tree_service_bee_ridge' },
	  { name: 'Fruitville', path: '/tree_service_fruitville' },
	  { name: 'The Meadows', path: '/tree_service_the_meadows' },
	  { name: 'Sarasota Springs', path: '/tree_service_sarasota_springs' },
	  { name: 'Kensington Park', path: '/tree_service_kensington_park' },
	  { name: 'Ridge Wood Heights', path: '/tree_service_ridge_wood_heights' },
      { name: 'Siesta Key', path: '/tree_service_siesta_key' },
      { name: 'Longboat Key', path: '/tree_service_longboat_key' },
	  { name: 'Lido Key', path: '/tree_service_lido_key' },
	  { name: 'Casey Key', path: '/tree_service_casey_key' },
      { name: 'Venice', path: '/tree_service_venice' },
	  { name: 'South Venice', path: '/tree_service_south_venice' },
	  { name: 'Nokomis', path: '/tree_service_nokomis' },
	  { name: 'Gulf Gate Estates', path: '/tree_service_gulf_gate_estates' },
      { name: 'Englewood', path: '/tree_service_englewood' },
      { name: 'Osprey', path: '/tree_service_osprey' },
      { name: 'Palmer Ranch', path: '/tree_service_palmer_ranch' },
      { name: 'North Port', path: '/tree_service_north_port' },
	  { name: 'Laurel', path: '/tree_service_laurel' },
	  { name: 'Vamo', path: '/tree_service_vamo' },
    ],
  },
  {
    county: 'Manatee County',
    cities: [
      { name: 'Bradenton', path: '/tree_service_bradenton' },
	  { name: 'Bradenton Beach', path: '/tree_service_bradenton_beach' },
	  { name: 'Holmes Beach', path: '/tree_service_holmes_beach' },
	  { name: 'Bayshore Gardens', path: '/tree_service_bayshore_gardens' },
	  { name: 'South Bradenton,', path: '/tree_service_south_bradenton' },
	  { name: 'Whitfield', path: '/tree_service_whitfield' },
	  { name: 'Whitfield Estates', path: '/tree_service_whitfield_estates' },
	  { name: 'Cortez', path: '/tree_service_cortez' },
	  { name: 'Myakka City,', path: '/tree_service_myakka_city' },
	  { name: 'Duette', path: '/tree_service_duette' },
	  { name: 'Tallevast', path: '/tree_service_tallevast' },
	  { name: 'Rubonia', path: '/tree_service_rubonia' },
	  { name: 'Samoset', path: '/tree_service_samoset' },
	  { name: 'Oneco,', path: '/tree_service_oneco' },
	  { name: 'Memphis', path: '/tree_service_memphis' },
      { name: 'West Bradenton', path: '/tree_service_bradenton' },
      { name: 'Palmetto', path: '/tree_service_palmetto' },
      { name: 'Parrish', path: '/tree_service_parrish' },
      { name: 'Lakewood Ranch', path: '/tree_service_lakewood_ranch' },
      { name: 'Ellenton', path: '/tree_service_ellenton' },
      { name: 'Anna Maria Island', path: '/tree_service_anna_maria' },
    ],
  },
  {
    county: 'Hillsborough County',
    cities: [
      { name: 'Tampa', path: '/tree_service_tampa' },
      { name: 'Riverview', path: '/tree_service_riverview' },
      { name: 'Ruskin', path: '/tree_service_ruskin' },
      { name: 'Brandon', path: '/tree_service_brandon' },
      { name: 'Apollo Beach', path: '/tree_service_apollo_beach' },
      { name: 'Sun City Center', path: '/tree_service_sun_city_center' },
	  { name: 'East Tampa', path: '/tree_service_east_tampa' },
	  { name: 'West Tampa', path: '/tree_service_west_tampa' },
	  { name: 'North Tampa', path: '/tree_service_north_tampa' },
	  { name: 'New Tampa', path: '/tree_service_new_tampa' },
	  { name: 'South Tampa', path: '/tree_service_south_tampa' },
	  { name: 'Downtown Tampa', path: '/tree_service_downtown_tampa' },
	  { name: 'Ybor City', path: '/tree_service_ybor_city' },
	  { name: 'Seminole Heights', path: '/tree_service_seminole_heights' },
	  { name: 'Hyde Park', path: '/tree_service_hyde_park' },
	  { name: 'Palma Ceia', path: '/tree_service_palma_ceia' },
	  { name: 'Carrollwood', path: '/tree_service_carrollwood' },
	  { name: 'Northdale', path: '/tree_service_northdale' },
	  { name: 'Lutz', path: '/tree_service_lutz' },
	  { name: 'Temple Terrace', path: '/tree_service_temple_terrace' },
	  { name: 'University', path: '/tree_service_university' },
	  { name: 'Town ‘n’ Country', path: '/tree_service_town_n_country' },
	  { name: 'Citrus Park', path: '/tree_service_citrus_park' },
	  { name: 'Westchase', path: '/tree_service_westchase' },
	  { name: 'Keystone', path: '/tree_service_keystone' },
	  { name: 'Egypt Lake-Leto', path: '/tree_service_egypt_lake_leto' },
	  { name: 'Valrico', path: '/tree_service_valrico' },
	  { name: 'Wimauma', path: '/tree_service_wimauma' },
	  { name: 'Gibsonton', path: '/tree_service_gibsonton' },
	  { name: 'Bloomingdale', path: '/tree_service_bloomingdale' },
	  { name: 'Progress Village', path: '/tree_service_progress_village' },
	  { name: 'Palm River-Clair Mel', path: '/tree_service_palm_river_clair_mel' },
	  { name: 'Seffner', path: '/tree_service_seffner' },
	  { name: 'Mango', path: '/tree_service_mango' },
	  { name: 'Fish Hawk', path: '/tree_service_fish_hawk' },
	  { name: 'Lithia', path: '/tree_service_lithia' },
	  { name: 'Balm', path: '/tree_service_balm' },
	  { name: 'South Hillsborough', path: '/tree_service_south_hillsborough' },
    ],
  },
  {
    county: 'Pinellas County',
    cities: [
      { name: 'Saint Petersburg', path: '/tree_service_stpete' },
	  { name: 'Saint Petersburg Beach', path: '/tree_service_st_pete_beach' },
	  { name: 'Gulfport', path: '/tree_service_gulfport' },
	  { name: 'South Pasadena', path: '/tree_service_south_pasadena' },
	  { name: 'Treasure Island', path: '/tree_service_treasure_island' },
	  { name: 'Madeira Beach', path: '/tree_service_madeira_beach' },
	  { name: 'Redington Beach', path: '/tree_service_redington_beach' },
	  { name: 'North Redington Beach', path: '/tree_service_north_redington_beach' },
	  { name: 'Redington Shores', path: '/tree_service_redington_shores' },
	  { name: 'Indian Shores', path: '/tree_service_indian_shores' },
	  { name: 'Indian Rocks Beach', path: '/tree_service_indian_rocks_beach' },
	  { name: 'Belleair Beach', path: '/tree_service_belleair_beach' },
	  { name: 'Belleair Shore', path: '/tree_service_belleair_shore' },
      { name: 'Pinellas Park', path: '/tree_service_pinellas_park' },
      { name: 'Tierra Verde', path: '/tree_service_tierra_verde' },
      { name: 'Pass-a-Grille,', path: '/tree_service_pass_a_grille' },
      { name: 'Lealman', path: '/tree_service_lealman' },
	  { name: 'Bay Pines', path: '/tree_service_bay_pines' },
    ],
  },
  {
    county: 'Davis Islands',
    cities: [
      { name: 'Davis Islands', path: '/tree_service_davis_islands' },
      { name: 'Harbour Island', path: '/tree_service_harbour_island' },
      { name: 'Ballast Point', path: '/tree_service_ballast_point' },
	  { name: 'Port Tampa City', path: '/tree_service_port_tampa_city' },
	  { name: 'Sulphur Springs', path: '/tree_service_sulphur_springs' },
	  { name: 'Forest Hills', path: '/tree_service_forest_hills' },
	  { name: 'Lake Magdalene', path: '/tree_service_lake_magdalene' },
	  { name: 'Greater Carrollwood', path: '/tree_service_greater_carrollwood' },
	  { name: 'Temple Crest', path: '/tree_service_temple_crest' },
	  { name: 'Lowry Park', path: '/tree_service_lowry_park' },
	  { name: 'Wellswood', path: '/tree_service_wellswood' },
	  { name: 'Palma Ceia West', path: '/tree_service_palma_ceia_west' },
	  { name: 'Virginia Park', path: '/tree_service_virginia_park' },
	  { name: 'Sunset Park', path: '/tree_service_sunset_park' },
    ],
  },
];
		
	return (
		<>
    <Helmet>
      <title>Sam's Tree Service - Expert Tree Removal</title>
      <meta name="description" content="Fully licensed and insured tree service in Sarasota, FL. We specialize in dangerous tree removal, trimming, and emergency services." />
    <link rel="canonical" href="https://samstreeservice.com" />
  	<link rel="preload" as="image" href={PosterImage} />
  	<link
  		rel="preload"
  		as="fetch"
  		href="https://d3q39nywk1l3el.cloudfront.net/static/media/SamsCut4_5.634078552d9891500f64.mp4"
  		crossOrigin="anonymous"
		/>
	{/*<link rel="preload" as="image" href="/public/logo_t2.webp" fetchpriority="high" />*/}
	</Helmet>
		<div id='main_indexDiv'>
			<div className="background-video">
					<video  ref={videoRef} autoPlay muted loop playsInline preload="metadata" poster={PosterImage}>
					<source src={videoSrc} type="video/mp4" />
    						Your browser does not support the video tag.
  					</video>
					  <div id='background_cover'></div>
			</div>
			<div className="module" id="moduleOne">
				<div id="index_div1-sub">
					<div id='index_div1-sub2'>
						<div className="text-container">
						<ReactCurvedText
							width={500}
      						height={200}
      						cx={250}
      						cy={350}
      						rx={230}
      						ry={230}
      						startOffset={180}
							reversed={true}
      						text="DANGEROUS TREES ARE OUR SPECIALTY !"
    					/>
						</div>
						<div id='slide_text1'></div>
						<div id='slide_text1_5'>SAM'S Tree Service</div>
						{/*<div id="slide_text2">Expert Tree Removal & Care Done Right</div>*/}
						<div id="slide_text2">Certified Experts For All Your Tree Service Needs</div>
						<div id="slide_text2_5">Dangerous Trees Are Our Specialty</div>
						<div id="slide_text3"><p>As a fully licensed, insured and locally owned  
							company, we proudly deliver top rated tree services 
							to residential and commercial clients in Sarasota and across 
							Southwest Florida. Our services include tree 
							removal, trimming, stump grinding, debris cleanup, 
							and 24/7 emergency assistance, with expert crane 
							services for even the toughest jobs.</p></div>
						
					</div>
				</div>
				<div id='index_buttons_1'>
					<div id='signuplink_index' 
  						onClick={(e) => {
    						e.preventDefault(); // Prevent the default link action
    						openModal();
  						}}>Get a Free Estimate!
					</div>
				

					<div id='about_link' onClick={handleNavigation}>
      					Learn More
    				</div>
				</div>
					{/*{isModalOpen && <UserModal onClose={closeModal} />}*/}
					{/*<UserModal isOpen={isModalOpen} onClose={closeModal} />*/}
					{isModalOpen && <UserModal isOpen={isModalOpen} onClose={closeModal} />}
			</div>
			<div id='moduleOne_half'>

			</div>
				<div className="module" id="moduleTwo">
				<div id='spacer_div'>
				<div id='divlink_container' ref={linksRef}>
					<div id='spacer_div_Link1' className={`spacer_div_Link ${isVisibleLinks  ? 'visible' : ''}`}
        				 style={{ transitionDelay: '.3s' }}>
							<div id='spacer_div_Link1_sub'>
							<h1><i className="bi bi-houses" style={{ fontSize: '2rem', color: 'green'}}></i>&nbsp;Residential Tree Services</h1>
							<p>We offer expert tree care for your home, including trimming, 
								pruning, and tree removal. Our team ensures your trees 
								remain healthy, enhancing your property's beauty and safety.</p>
								<ul>
									<li>Preventing damage from hazardous branches</li>
									<li>Removing trees before hurricane season</li>
									<li>Improving tree health through proper maintenance</li>
									<li>Enhancing curb appeal with expert pruning</li>	
								</ul>
							
							</div>
					</div>
					<div id='spacer_div_Link2' className={`spacer_div_Link ${isVisibleLinks  ? 'visible' : ''}`}
        				 style={{ transitionDelay: '.6s' }}>
							<div id='spacer_div_Link2_sub'>
							<h1><i className="bi bi-buildings" style={{ fontSize: '2rem', color: 'green' }}></i>&nbsp;Commercial Tree Services</h1>
							<p>We provide safe, 
								efficient, and budget-friendly tree removal services 
								tailored to meet your commercial needs.</p>
								<ul>
									<li>Large-scale tree removal for commercial properties</li>
									<li>Land clearing for new construction projects</li>
									<li>Preventing tree-related damage to buildings and signage</li>
									<li>Routine pruning and maintenance for a professional appearance</li>	
								</ul>
							</div>
					</div>
					<div id='spacer_div_Link3' className={`spacer_div_Link ${isVisibleLinks  ? 'visible' : ''}`}
        				 style={{ transitionDelay: '.9s' }}>
							<div id='spacer_div_Link2_sub'>
							<h1><i className="bi bi-exclamation-diamond"style={{ fontSize: '2rem', color: 'green' }} ></i>&nbsp;24/7 Emergency Tree Services</h1>
							<p>When urgent tree issues arise, our 24/7 emergency tree service is here to help. 
								We handle dead or infested trees, trees on power lines, and trees with 
								immediate safety concerns, including leaning, split, or uprooted trees, 
								ensuring quick and safe removal.</p>
								<ul>
									<li>24/7 emergency tree service</li>
									<li>Fallen tree removal</li>
									<li>Storm damage tree cleanup</li>
									<li>Tree disaster cleanup</li>	
								</ul>		
							</div>
					</div>
					
				</div>
				</div>
					<div id='index_div3'>

						
				
					
						<div id='index_div4' ref={textRef} className={`text_div_Link ${isVisibleLinks  ? 'visible' : ''}`}>
							<div id='icon_two_half0'>
								<div id='two_half_text0_1'><h1> - - - - - -&nbsp;&nbsp;</h1>
								</div><div id='icon_two_half_icon0'><GiPalmTree /></div>
								<div id='two_half_text0_2'><h1>&nbsp;&nbsp;- - - - - -</h1></div>
							</div>
							<div id='index_div4_sub'>
								<h1>Providing Professional Tree Care Throughout Sarasota & Southwest Florida</h1>
								<h2>From Dangerous Tree Removal to Routine Maintenance - We Handle It All!</h2>
								<p>At <strong>Sam's Tree Service</strong>, we provide expert tree removal, 
								   trimming, pruning, and stump grinding across Sarasota and Southwest 
								   Florida. As a Certified Arborist and fully insured company, we specialize 
								   in handling <strong>dangerous trees</strong>, emergency removals, and 
								   land clearing. Our team is equipped with cranes for complex removals and 
								   offers debris hauling to leave your property clean and safe. Whether you 
								   need tree cutting, stump removal, or emergency tree care, we guarantee 
								   top-quality service at an affordable price</p>
								   {/*<h3>We proudly serve <Link to="/tree_service_sarasota" style={{ textDecoration: 'underline', color: 'inherit', fontWeight: '600' }}>
        							Sarasota</Link>, <Link to="/tree_service_bradenton" style={{ textDecoration: 'underline', color: 'inherit', fontWeight: '600' }}>
        							 Bradenton</Link>, <Link to="/tree_service_bradenton" style={{ textDecoration: 'underline', color: 'inherit', fontWeight: '600' }}>
        							 West Bradenton</Link>, <Link to="/tree_service_siesta_key" style={{ textDecoration: 'underline', color: 'inherit', fontWeight: '600' }}>
        							  Siesta Key</Link>, <Link to="/tree_service_longboat_key" style={{ textDecoration: 'underline', color: 'inherit', fontWeight: '600' }}>
        							 Longboat Key</Link>, <Link to="/tree_service_lakewood_ranch" style={{ textDecoration: 'underline', color: 'inherit', fontWeight: '600' }}>
        							 Lakewood Ranch</Link>, <Link to="/tree_service_venice" style={{ textDecoration: 'underline', color: 'inherit', fontWeight: '600' }}>
        							 Venice</Link>, <Link to="/tree_service_englewood" style={{ textDecoration: 'underline', color: 'inherit', fontWeight: '600' }}>
        							 Englewood</Link>, <Link to="/tree_service_palmetto" style={{ textDecoration: 'underline', color: 'inherit', fontWeight: '600' }}>
        							 Palmetto</Link>, <Link to="/tree_service_parrish" style={{ textDecoration: 'underline', color: 'inherit', fontWeight: '600' }}>
        							 Parrish</Link>, <Link to="/tree_service_osprey" style={{ textDecoration: 'underline', color: 'inherit', fontWeight: '600' }}>
        							 Osprey</Link>, <Link to="/tree_service_palmer_ranch" style={{ textDecoration: 'underline', color: 'inherit', fontWeight: '600' }}>
        							 Palmer Ranch</Link>, <Link to="/tree_service_ruskin" style={{ textDecoration: 'underline', color: 'inherit', fontWeight: '600' }}>
									 Ruskin</Link>, <Link to="/tree_service_stpete" style={{ textDecoration: 'underline', color: 'inherit', fontWeight: '600' }}>
									 Saint Petersburg</Link>, <Link to="/tree_service_pinellas_park" style={{ textDecoration: 'underline', color: 'inherit', fontWeight: '600' }}>
									 Pinellas Park</Link>, <Link to="/tree_service_riverview" style={{ textDecoration: 'underline', color: 'inherit', fontWeight: '600' }}>
									 Riverview</Link>, <Link to="/tree_service_tampa" style={{ textDecoration: 'underline', color: 'inherit', fontWeight: '600' }}>
        							 Tampa</Link>,     
								    
									  and surrounding areas.</h3>*/}
									
								<div id='county_service_area'>
										
  								<h3>We proudly serve</h3>

  									<div id='county_dropdown_container'>
    									{countyData.map((region) => (
      									<div className='county_dropdown_item' key={region.county}>
        								<button
          									type='button'
          									ref={(el) => {
            								countyButtonRefs.current[region.county] = el;
          									}}
          								className='county_label county_button'
          									onClick={(e) =>
            									openCounty === region.county? closeCountyMenu(): 
												openCountyMenu(region.county, e)
          									}
          									aria-expanded={openCounty === region.county}
          									aria-haspopup='menu'
        									>
          									{region.county} <span className='county_caret'>▾</span>
        								</button>
      									</div>
    									))}

    									<span id='county_suffix'>&nbsp;and surrounding areas.</span>
  									</div>
								</div>
									{openCounty && createPortal(
    								<div id='county-floating-menu' className='county_floating_menu'
      									style={{ top: `${menuPosition.top}px`, left: `${menuPosition.left}px`,
        										width: `${menuPosition.width}px`, }}>
      										{countyData.find((region) => region.county === openCounty)?.cities.map((city) => (
          									<Link
            									key={city.name}
            									to={city.path}
            									className='county_dropdown_link'
            									onClick={() => {
              									window.scrollTo(0, 0);
              									closeCountyMenu();
            									}}
          									>
            									{city.name}
          									</Link>
        									))}
    								</div>, document.body)}

							<div id='button_container_index'>		  

								<div id='signuplink_index2' 
  									onClick={(e) => {
    									e.preventDefault(); // Prevent the default link action
    									openModal();
  									}}>Get a Free Estimate!
								</div>

								<div id='bloglink_index' 
  									onClick={handleNavigation3}>Read Our Blog
								</div>

							</div>
							</div>	
						</div>
						<div id='picture_slides'>
							<div id='container_Slide'>
								<SlideInDiv style={{ transitionDelay: '3s' }}>
									<div id='slideInDive'></div>
								</SlideInDiv>
							</div>
							<div id='slideCon'>
								<SlideInDivLeft style={{ transitionDelay: '5s' }}>
									<div id='slideInDive2'></div>
								</SlideInDivLeft>
							</div>
							<div id='slideCon2'>
								<SlideInDiv style={{ transitionDelay: '7s' }}>
									<div id='slideInDive3'></div>
								</SlideInDiv>	
							</div>
							<div id='slideCon4'>
								<SlideInDivLeft style={{ transitionDelay: '9s' }}>
									<div id='slideInDive4'></div>
								</SlideInDivLeft>	
							</div>
						</div>
						
				</div>
				
				</div>
				<div className="module" id='choose_us'>
							<div id='divider_heading'><h1>Why Choose Us?</h1></div>
							<div id='dividers_container'>
									<div className='dividers'><TbShieldCheckFilled className="check"/><p>Fully insured for your peace of mind</p></div>
									<div className='dividers'><TbShieldCheckFilled className="check"/><p>Emergency tree removal services available 24/7</p></div>
									<div className='dividers'><TbShieldCheckFilled className="check"/><p>Affordable rates and competitive prices</p></div>
									<div id='dividers4' className='dividers'><TbShieldCheckFilled className="check"/><p>Highly trained professionals with years of experience</p></div>
							</div>
						
				</div>
				<div className="module" id="moduletwo_and_half">
					<Arborist/>
					{/*<div id='moduletwo_and_half_picdiv'></div>
						<div id='moduletwo_and_half_title'>
							<div id='icon_two_half'>
								<div id='two_half_text1'><h1> - - - - - -&nbsp;&nbsp;</h1>
								</div><div id='icon_two_half_icon'></div>
								<div id='two_half_text2'><h1>&nbsp;&nbsp;- - - - - -</h1></div>
							</div>
							<div id='two_half_text3'>
								<h1>Certified Arborist Tree Service</h1>
								<p>At SAM'S Tree Service, you will have the 
									privilege of working directly with an ISA 
									Certified Arborist! </p>
									<h3>Why should you choose 
									an ISA Certified Arborist for your tree 
									care needs?</h3>
							</div>
						</div>
						<div id='centerdiv_index'>
						<div id='moduletwo_and_half_text_container'>
							<div className='moduletwo_and_half_text'>
								<div className='circle_div'><IoSchoolOutline/></div>
								<div className='inside_text' id='insideeDiv_moduletwo_and_half_text1'>
									<h1>Extensive Knowledge and Training</h1>
										<p> An ISA certified arborist possesses a vast 
											knowledge base and specialized training in 
											all aspects of arboriculture. From tree biology 
											to maintenance practices and safety procedures, 
											these tree specialist professionals have undergone rigorous 
											examinations to demonstrate their high level of 
											competence in tree care.
										</p>
								
								</div>
							</div>
						<div className='moduletwo_and_half_text'>
							<div className='circle_div'><LuShieldAlert /></div>
							<div className='inside_text' id='insideeDiv_moduletwo_and_half_text2'>
								<h1>Safety</h1>
								<p> ISA certified arborists offer a wide range of 
									services, including pruning, removal, fertilization, 
									pest and disease monitoring, and expert advice on 
									all things tree-related. With their wealth of 
									knowledge and expertise, they can perform these 
									tasks safely and efficiently.
								</p>
							</div>
							</div>
						<div className='moduletwo_and_half_text'>
							<div className='circle_div'><GiTreeBranch /></div>
							<div className='inside_text' id='insideeDiv_moduletwo_and_half_text3'>
								<h1>Comprehensive Services</h1>
								<p> ISA certified arborists provide a 
									comprehensive range of services, such 
									as pruning, removal, fertilization, pest 
									and disease monitoring, and consultation 
									on tree-related issues. Their knowledge 
									and expertise enable them to carry out these 
									tasks efficiently and safely.
								</p>
							</div>
						</div>
						<div className='moduletwo_and_half_text'>
							<div className='circle_div'><TbTrees /></div>
							<div className='inside_text' id='insideeDiv_moduletwo_and_half_text4'>
								<h1>Long-term Health of Your Trees</h1>
								<p> Trees are a long-term investment, and an 
									ISA certified arborist understands this. 
									They work diligently to ensure the longevity 
									of your trees by diagnosing and treating any 
									diseases or pest issues that may be affecting 
									them. Trusting your tree care needs to an ISA 
									certified arborist guarantees the health and 
									well-being of your trees for years to come.
								</p>
							</div>
						</div>
						</div>
						<div id='moduletwo_and_halfpic'></div>
						</div>*/}
						
				</div>
				{/*<div className="module" id="moduleThree">*/}
				<div 
  					className={`module ${moduleThreeBgLoaded ? 'bg-loaded' : ''}`} 
  					id="moduleThree"
  					ref={moduleThreeRef}
				>
        		  <div id='index_div5'>
					<div id='index_div5_sub2'>
						<div id='index_div5_heading'>
							<div id='icon_two_half2'>
								<div id='two_half_text2_1'><h1> - - - - - -&nbsp;&nbsp;</h1>
								</div><div id='icon_two_half_icon2'><GiWillowTree /></div>
								<div id='two_half_text2_2'><h1>&nbsp;&nbsp;- - - - - -</h1></div>
							</div>
							<h1>Explore Our Services</h1>
							<p>With unmatched expertise, a commitment to safety, 
								and a reputation for professionalism and 
								reliability, we're your trusted partner for 
								all tree service needs in Sarasota and Southwest Florida. 
								Available 24/7, we're ready to assist whenever you reach out.</p>
							</div>
							<div id='index_div5_box_container' ref={centerRef}>
								<div  id='index_div5_box1' className={`index_div5_box ${isVisibleCenter ? 'visible' : ''}`} 
								style={{ transitionDelay: '.3s' }}>
									<Link to="/tree_trimming" className='service-link' style={{ textDecoration: 'none' }} onClick={() => window.scrollTo(0, 0)}>
									<div className='index_div5_box_sub_container'>
									<div className='index_div5_box_sub'>
										
										<h1><LuTrees className='index_div5_icon'/>&nbsp;&nbsp;Tree Trimming</h1>
										<p>Professional tree trimming to enhance health, safety, and beauty.</p>
										
									</div>
									<div className='arrow_div'><FaArrowAltCircleRight /></div>
									<div className='index_div5_box_pic' id='index_div5_box_pic1'></div>
									</div>
									</Link>
								</div>
								<div className={`index_div5_box ${isVisibleCenter ? 'visible' : ''}`} 
								style={{ transitionDelay: '.6s' }}>
									<Link to="/tree_removal" class='service-link' style={{ textDecoration: 'none' }} onClick={() => window.scrollTo(0, 0)}>
									<div className='index_div5_box_sub_container'>
									<div className='index_div5_box_sub'>
										
										<h1><GiAxeInStump className='index_div5_icon'/>&nbsp;&nbsp;Tree removal</h1>
										<p>Safe and efficient tree removal tailored to your needs.</p>
										
									</div>
									<div className='arrow_div'><FaArrowAltCircleRight /></div>
									<div className='index_div5_box_pic' id='index_div5_box_pic2'></div>
									</div>
									</Link>
								</div>
								<div className={`index_div5_box ${isVisibleCenter ? 'visible' : ''}`} 
								style={{ transitionDelay: '.9s' }}>
									<Link to="/stump_removal" class='service-link' style={{ textDecoration: 'none' }} onClick={() => window.scrollTo(0, 0)}>
									<div className='index_div5_box_sub_container'>
									<div className='index_div5_box_sub'>
										
										<h1><GiStumpRegrowth className='index_div5_icon'/>&nbsp;&nbsp;Stump Removal</h1>
										<p>Reliable stump removal for a clean and polished landscape..</p>
										
									</div>
									<div className='arrow_div'><FaArrowAltCircleRight /></div>
									<div className='index_div5_box_pic' id='index_div5_box_pic3'></div>
									</div>
									</Link>
								</div>
								<div className={`index_div5_box ${isVisibleCenter ? 'visible' : ''}`} 
								style={{ transitionDelay: '1.2s' }}>
									<Link to="/debris_hauling" class='service-link' style={{ textDecoration: 'none' }} onClick={() => window.scrollTo(0, 0)}>
									<div className='index_div5_box_sub_container'>
									<div className='index_div5_box_sub'>
										
										<h1><GiTruck className='index_div5_icon'/>&nbsp;&nbsp;Debris Hauling</h1>
										<p>Clearing the Way: Efficient Debris Removal for a Cleaner Space</p>
										
									</div>
									<div className='arrow_div'><FaArrowAltCircleRight /></div>
									<div className='index_div5_box_pic' id='index_div5_box_pic4'></div>
									</div>
									</Link>
								</div>
							</div>
					</div>
				</div>
      		</div>
			  <div className="module" id="modulefour">
				<Testimonials/>
  			</div>
			<div className="module" id="modulefive">
				<div   className="sticky-element-container ">
      				<div  ref={stickyRef}className="background-div">
        				<div ref={overlayRef} className="overlay-container">
          					<div id='about_overlayText'>
							  	<div id='icon_five2'>
									<div id='five_text2_1'><h1> - - - - - -&nbsp;&nbsp;</h1></div>
									<div id='icon_five_icon2'><GiBirchTrees /></div>
									<div id='five_text2_2'><h1>&nbsp;&nbsp;- - - - - -</h1></div>
								</div>
            					<h1>Frequently Asked Questions</h1>
            					<p>Have questions about our services? Take a look at some frequently 
									asked questions below..</p>
          					</div>
							<div id='collapsible'>
								<Collapsible collapsibleData={collapsibleData} />
							</div>
						</div>
						<div id='video_faqsdiv'>
						<div id='about_pic_div1'>	
						    <video id='about_pic_div1_video' autoPlay muted loop playsInline>
    							<source src={Quest_video} type="video/mp4" />
    							Your browser does not support the video tag.
  							</video>
						</div>
							<div id='about_pic_div2'></div>
						</div>
      				</div>
				</div>
			</div>
			<div className="module" id="modulesix">
				{/*<Gallery/>*/}
				<Suspense fallback={null}>
  					<Gallery />
				</Suspense>
			</div>
		 <Footer/>
		</div>
		</>
	);
	
};

export default Home;



/*crossOrigin="anonymous" fetchPriority="high".  fetchpriority="high"*/
/*<link
  		rel="preload"
  		as="video"
  		href="https://d3q39nywk1l3el.cloudfront.net/static/media/SamsCut4_5.634078552d9891500f64.mp4"
  		type="video/mp4"
		/>	*/			

/*
				<div id='testimonials_title'>
				<div id='icon_four2'>
					<div id='four_text2_1'><h1> - - - - - -&nbsp;&nbsp;</h1></div>
					<div id='icon_four_icon2'><GiPalmTree /></div>
					<div id='four_text2_2'><h1>&nbsp;&nbsp;- - - - - -</h1></div>
				</div>
				<div id='testimonials_title_sub'>
					<h1>Real Feedback, Real Results</h1>
				</div>
				</div>
			  <div className="testimonials-container">
      			<button className="scroll-btn left" onClick={() => scrollLeft()}>
        			&larr;
     			 </button>
      		  <div className="testimonials-wrapper" ref={scrollRef}>
       			  {testimonialsData.map((testimonial, index) => (
          	  <div className="testimonial-box" key={index}
					>
            	<img
              		src={testimonial.image}
              		alt={`Testimonial from ${testimonial.name}`}
           	  		className="testimonial-image"
					style={{ padding: '0', margin: '0' }}
            	/>
            	<p className="review">"{testimonial.review}"</p>
            	<h3 className="customer-name">- {testimonial.name}</h3>
          	  </div>
        		))}
      		  </div>
      			<button className="scroll-btn right" onClick={() => scrollRight()}>
        			&rarr;
      			</button>
    		 </div>

			 	<div id='reviewlink_index' 
  					onClick={handleNavigation2}
  					>More Reviews
				</div>

			 <div id='modulesix_pic2'>
						<div id='mod61' className='mod6_widgits'>
							<div className='Mod6_widget_text' id='Mod6_text1'>
								<div className='icon-wood_widget_div' ><TbShieldCheckFilled className="icon-wood_widget"/></div>
								<div className='icon-wood_widget_div_sub'ref={ref}><h1>{count}+</h1><p>Five-Star Reviews</p></div>
							</div>
						</div>
						<div  id='mod62' className='mod6_widgits'>
							<div className='Mod6_widget_text' id='Mod6_text2'>
								<div className='icon-wood_widget_div' ><TbShieldCheckFilled className="icon-wood_widget"/></div>
								<div className='icon-wood_widget_div_sub' ref={ref2}><h1>{percentage}%</h1><p>Satisfaction Guaranteed</p></div>
							</div>
						</div>
						<div  id='mod63' className='mod6_widgits'>
							<div className='Mod6_widget_text' id='Mod6_text3'>
								<div className='icon-wood_widget_div' ><TbShieldCheckFilled className="icon-wood_widget"/></div>
								<div className='icon-wood_widget_div_sub' ref={ref3}><h1>{experience}+</h1><p>Years of Experience</p></div>
							</div>
						</div>
						<div  id='mod64' className='mod6_widgits'>
							<div className='Mod6_widget_text' id='Mod6_text4'>
								<div className='icon-wood_widget_div' ><TbShieldCheckFilled className="icon-wood_widget"/></div>
								<div className='icon-wood_widget_div_sub'><h1>A +</h1><p>BBB Rating</p></div>
							</div>
						</div>
				
				</div>*/	
				
/*<div id='modulesix_pic'>
				<div id='modulesix_text'>
					<div id='icon_six2'>
						<div id='six_text2_1'><h1> - - - - - -&nbsp;&nbsp;</h1></div>
						<div id='icon_six_icon2'><GiFruitTree /></div>
						<div id='six_text2_2'><h1>&nbsp;&nbsp;- - - - - -</h1></div>
					</div>				
					<h1>Explore Our Tree Service Expertise</h1>
				</div>
				<div id="collect-grid-container" ref={imageRef}>
					{images.map((image) => (
				
				<div className={`collect-grid-item ${isVisibleImage  ? 'visible' : ''}`} key={image.id}  style={{ transitionDelay: '.3s' }} onClick={() => handleGridItemClick(image)}>
					<img src={image.url} alt={image.alt} />
				</div>
			))}
				
			</div>
			<div className="modal-overlay2"></div>
			<div className="modal-container2">
				{expandedImage && (
					<ExpandedImage imageUrl={expandedImage.url} relatedImages={expandedImage.relatedImages} onClose={handleCloseExpandedImage} />
				)}
			</div>
					
				</div>
					
				
*/
/*const images = [
		{ id: 1, url: Image9, alt: 'gallery Image 1 tree service'},
	  	{ id: 2, url: Image10, alt: 'gallery Image 2 tree service '},
	  	{ id: 3, url: Image12, alt: 'gallery Image 3 tree service'},
	  	{ id: 4, url: Image1, alt: 'gallery Image 4 tree service'},
	  	{ id: 5, url: Image113, alt: 'gallery Image 5 tree service'},
	  	{ id: 6, url: Image45, alt: 'gallery Image 6 tree service' },
	  	{ id: 7, url: Image48, alt: 'gallery Image 7 tree service' },
	  	{ id: 8, url: Image52, alt: 'gallery Image 8 tree service' },
	  ];*/

/*
 const prepareImagesWithOrder = (images) => {
		return images.map((image, index) => ({
		  ...image,
		  relatedImages: [
			image.url,
			...images
			  .slice(index + 1)
			  .concat(images.slice(0, index))
			  .map((img) => img.url),
		  ],
		}));
	  };

	  const updatedImages = prepareImagesWithOrder(images);




const handleGridItemClick = (image) => {
			const selectedImage = updatedImages.find((img) => img.id === image.id);
  		setExpandedImage(selectedImage);
		const modalContainer = document.querySelector('.modal-container2');
		modalContainer.style.top = '50%'; 
		modalContainer.style.left = '50%'; 
		modalContainer.style.transform = 'translate(-50%, -50%)'; 
		modalContainer.style.width = '90%'; 
		modalContainer.style.height = '100vh'; 
		document.querySelector('.modal-overlay2').classList.add('show');
		modalContainer.classList.add('show');
		};

		const handleCloseExpandedImage = () => {
		setExpandedImage(null);
		document.querySelector('.modal-overlay2').classList.remove('show');
		document.querySelector('.modal-container2').classList.remove('show');
		};*/
		
		

